import React, { useState } from "react";
import axios from "axios";
import "./Admissionfrom.css"
import { Link } from "react-router-dom";

const collegeData = {
  "PT L.R. College of Technology": {
    Technology: ["B.Tech", "M.Tech", "Diploma"],
    Management: ["BCA", "BBA", "MBA"],
    Pharmacy: ["B.Pharma", "D.Pharma"],
  },
};

const courseData = {
  BTech: ["Mechanical Engineering", "Electrical Engineering", "CSE", "CS/IT", "Civil Engineering", "ECE Engineering"],
  MTech: ["CSE", "Mechanical", "ECE"],
  Diploma: ["Mechanical", "Electrical", "DMLT"],
  BCA: ["BCA"],
  BBA: ["BBA"],
  MBA: ["MBA"],
  BPharma: ["B.Pharma"],
  DPharma: ["D.Pharma"],
};

const AdmissionForm = () => {
  const [branch, setBranch] = useState("");
  const [program, setProgram] = useState("");
  const [form, setForm] = useState({
    studentName: "",
    mobile: "",
    fatherName: "",
    motherName: "",
    dob: "",
    gender: "",
    nationality: "",
    aadhar: "",
    email: "",
    address: "",
    category: "GEN",
    qualification: "",
    tenthPercent: "",
    twelfthPercent: "",
    accountNo: "",
    ifsc: "",
  });

  const [files, setFiles] = useState({
    tenthMarksheet: null,
    twelfthMarksheet: null,
    photo: null,
    aadharFront: null,
    aadharBack: null,
    paymentScreenshot: null,
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFiles({ ...files, [e.target.name]: e.target.files[0] });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("college", "PT L.R. College of Technology");
    formData.append("branch", branch);
    formData.append("program", program);
    formData.append("course", courseData[program.replace(".", "")]?.[0] || "");

    Object.entries(form).forEach(([key, value]) => {
      formData.append(key, value);
    });

    Object.entries(files).forEach(([key, file]) => {
      if (file) formData.append(key, file);
    });

    try {
      const res = await axios.post("http://localhost:5000/submit", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      alert("Form submitted successfully!");
      console.log(res.data);
    } catch (err) {
      alert("Error submitting form!");
      console.error(err);
    }
  };

  return (
    

<form className="admission-form" onSubmit={handleSubmit}>
  <h1>Welcome to Pt. L.R. Group of Institution Online <br />Admission Form</h1>
  

  <div>
    <label className="labe">Branch</label>
    <select className="form-control inp" onChange={(e) => setBranch(e.target.value)}>
      <option value="">Select Branch</option>
      {Object.keys(collegeData["PT L.R. College of Technology"]).map((b) => (
        <option key={b} value={b}>{b}</option>
      ))}
    </select>
  </div>

  {branch && (
    <div>
      <label className="labe">Program</label>
      <select className="form-control inp" onChange={(e) => setProgram(e.target.value)}>
        <option value="">Select Program</option>
        {collegeData["PT L.R. College of Technology"][branch].map((prog) => (
          <option key={prog} value={prog}>{prog}</option>
        ))}
      </select>
    </div>
  )}

  {program && (
    <div>
      <label className="labe">Course</label>
      <select className="form-control inp">
        {courseData[program.replace(".", "")]?.map((course) => (
          <option key={course}>{course}</option>
        ))}
      </select>
    </div>
  )}

  <div className="grid">
    <input name="studentName" type="text" placeholder="Student Name" className="form-control inp" onChange={handleChange} required />
    <input name="mobile" type="number" placeholder="Mobile No." className="form-control inp" onChange={handleChange} required />
    <input name="fatherName" type="text" placeholder="Father's Name" className="form-control inp" onChange={handleChange} required />
    <input name="motherName" type="text" placeholder="Mother's Name" className="form-control inp" onChange={handleChange} required />
    <input type="date"  name="dob" className="form-control inp" onChange={handleChange} required />
    <select name="gender"  placeholder="Gender" className="form-control inp" onChange={handleChange} required >
  
    <option>Male</option>
    <option>Female</option>
    <option>Other</option>
    </select>
    <input name="nationality" type="text" placeholder="Nationality" className="form-control inp" onChange={handleChange} required />
    <input name="aadhar" type="number" placeholder="Aadhar Card No." className="form-control inp" onChange={handleChange} required />
    <input name="email" type="email" placeholder="Email ID" className="form-control inp" onChange={handleChange} required />
    <input name="address" type="text" placeholder="Corresponding Address" className="form-control inp" onChange={handleChange} required />
    <select name="category" className="form-control inp" onChange={handleChange} required>
      <option>GEN</option>
      <option>OBC</option>
      <option>BC</option>
      <option>SC/ST</option>
      <option>Other</option>
    </select>
  </div>

  <div>
    <label className="labe">Qualification</label>
    <select name="qualification" className="form-control inp" onChange={handleChange} required>
      <option>10th Pass</option>
      <option>12th Pass</option>
      <option>ITI</option>
      <option>Diploma</option>
      <option>B.Tech</option>
      <option>Other</option>
    </select>

    <label className="labe">10th Marksheet</label>
    <input type="file" name="tenthMarksheet" className="form-control inp" onChange={handleFileChange} required />

    <label className="labe">12th Marksheet</label>
    <input type="file" name="twelfthMarksheet" className="form-control inp" onChange={handleFileChange} required />

    <label className="labe">Photo</label>
    <input type="file" name="photo" className="form-control inp" onChange={handleFileChange} required />

    <label className="labe">Aadhar Front</label>
    <input type="file" name="aadharFront" className="form-control inp" onChange={handleFileChange} required />

    <label className="labe">Aadhar Back</label>
    <input type="file" name="aadharBack" className="form-control inp" onChange={handleFileChange} required />

    <input name="tenthPercent" placeholder="Mention class 10th%" className="form-control inp" onChange={handleChange} required />
    <input name="twelfthPercent" placeholder="Mention class 12th %" className="form-control inp" onChange={handleChange} required />
  </div>

  <div>
    <h3>Fee Section</h3>
    <input name="accountNo" placeholder="Mention Transaction ID" className="form-control inp" onChange={handleChange} required />
    <input name="ifsc" placeholder="Payment Holder Name" className="form-control inp" onChange={handleChange} required />
    <label className="labe">Payment Screenshot</label>
    <input type="file" name="paymentScreenshot" className="form-control inp" onChange={handleFileChange} required />
  </div>

  <button type="submit" className="bton">Submit</button>
  <button className="bton"> <Link to="/Account"> Show Account Details</Link></button>
  <button className="bton"> <Link to="/Step"> Show Step Page</Link></button>
</form>

  );
};

export default AdmissionForm;
